import { cleanQuarter, cleanYear } from '@/navigation/utils';
import { DurationLike, QuarterNumbers } from 'luxon';
import { computed, Ref, toValue } from 'vue';

export const MINIMAL_YEAR = 2000;
export const MAXIMAL_YEAR = 2099;

export function useTimelineIntervalChanger(
    quarter: Ref<string>,
    year: Ref<string>,
    timelineDataLoading: Ref<boolean>,
    allocationsCount: Ref<number>,
    addToStartDateTime: (duration: DurationLike) => void,
    subtractFromStartDateTime: (duration: DurationLike) => void,
) {
    function onChangeQuarter(newQuarter: QuarterNumbers) {
        const currentQuarter = cleanQuarter(quarter.value);
        const quarterDifference = Math.abs(newQuarter - currentQuarter);
        if (newQuarter < currentQuarter) {
            subtractFromStartDateTime({ quarters: quarterDifference });
        } else {
            addToStartDateTime({ quarters: quarterDifference });
        }
    }

    function onChangeYear(newYear: number) {
        const currentYear = cleanYear(year.value);
        const yearDifference = Math.abs(newYear - currentYear);
        if (newYear < currentYear) {
            subtractFromStartDateTime({ years: yearDifference });
        } else if (newYear > currentYear) {
            addToStartDateTime({ years: yearDifference });
        }
    }

    function onClickPreviousQuarter() {
        subtractFromStartDateTime({ quarters: 1 });
    }

    function onClickNextQuarter() {
        addToStartDateTime({ quarters: 1 });
    }

    const warningNoAllocations = computed(() => {
        if (toValue(timelineDataLoading) || toValue(allocationsCount) > 0) {
            return null;
        }

        return {
            buttonJumpToPreviousAllocations: 'Hidden' as const,
            buttonJumpToNextAllocations: 'Hidden' as const,
        };
    });

    return {
        warningNoAllocations,
        onChangeQuarter,
        onChangeYear,
        onClickPreviousQuarter,
        onClickNextQuarter,
    };
}
